import { type AxiosError } from 'axios';
import { STATUS_CODE } from 'data/enums';

export const isMaintenanceMode = (error: AxiosError) =>
  error?.response?.status === STATUS_CODE.SERVICE_UNAVAILABLE &&
  (error?.response?.data as Record<string, any>)?.reason === 'maintenance';
